import { render, staticRenderFns } from "./ConfirmResultGrade10Table.vue?vue&type=template&id=2b7f4645&"
import script from "./ConfirmResultGrade10Table.vue?vue&type=script&lang=js&"
export * from "./ConfirmResultGrade10Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports